import React from 'react'
import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
  Typography,
} from '@material-ui/core'

import { ProjectPreview } from '../../types/Project'

const styles = (theme: Theme) => {
  const {
    palette: {
      text: { secondary: textSecondary, primary: textPrimary },
    },
    breakpoints: { up },
  } = theme

  const sm = up('sm')
  const lg = up('lg')
  const xl = up('xl')

  return createStyles({
    root: {
      [sm]: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '0.8125rem',
      flexShrink: 0,
      marginBottom: '0.5rem',
      [sm]: {
        marginBottom: 0,
      },
      [xl]: {
        marginRight: '1rem',
      },
    },
    title: {
      fontWeight: 'bold',
      color: textPrimary,
      marginRight: '0.375rem',
      fontSize: '1rem',
      lineHeight: '1.1875rem',
      [lg]: {
        fontSize: '1.5625rem',
        lineHeight: '1.8125rem',
        marginRight: '1rem',
      },
    },
    divider: {
      display: 'none',
      [sm]: {
        display: 'block',
        width: '1.1875rem',
        height: '0.1875rem',
        backgroundColor: textPrimary,
      },
      [xl]: {
        width: '3.4375rem',
        height: '0.25rem',
      },
    },
    description: {
      color: textSecondary,
      fontSize: '0.8125rem',
      lineHeight: '0.9375rem',
      [theme.breakpoints.up('md')]: {
        fontSize: '0.6875rem',
      },
      [lg]: {
        fontSize: '1.25rem',
        lineHeight: 1,
      },
      [xl]: {
        fontSize: '1.5625rem',
        lineHeight: '1.8125rem',
      },
    },
  })
}

interface Props extends WithStyles<typeof styles>, ProjectPreview {
  children?: React.ReactNode
}

const Toolbar = ({ classes, title, description, children = null }: Props) => {
  return (
    <div className={classes.root}>
      <div className={classes.titleContainer}>
        <Typography variant="h3" className={classes.title}>
          {title}
        </Typography>
        <div className={classes.divider} />
      </div>
      <Typography className={classes.description}>{description}</Typography>
      {children}
    </div>
  )
}

export default withStyles(styles)(Toolbar)
